<template>
  <div>
    <b-row align-h="center">
      <b-col sm="12" md="6" lg="4" class="text-center">
        <Auth source="cws" :service="this.oauthParams.client_id" />
      </b-col>
    </b-row>
    <!-- <b-row align-h="center">
      <b-col sm="12" md="12" lg="10" v-if="isAuthInCurrentRegion">
        <b-alert v-if="error && !showModal" show variant="danger">
          <span v-if="error.type">{{ error.type }}</span
          ><span v-if="error.description"> / {{ error.description }}</span>
        </b-alert>
        <div>
          <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
        </div>
      </b-col>
    </b-row> -->

    <div v-if="isAuthInCurrentRegion">
      <br />
      <b-row align-h="center">
        <b-col sm="12" md="7" lg="5">
          <h1 style="text-align:center">{{ partnerName }}</h1>
          <hr />
          <br />
          <h3 style="text-align:center">{{ $t("sign_in_with") }}</h3>
          <b-form @submit.prevent="partnerAuth">
            <b-alert v-if="error" show variant="danger">{{
              error.description
            }}</b-alert>
            <b-form-group
              :label="$t('user_partner_login', { service: this.partnerName })"
              label-for="user_login"
            >
              <b-form-input
                id="user_login"
                v-model="userForm.login"
                type="text"
                required
                :placeholder="$t('enter_user_login')"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              :label="$t('user_partner_password',{ service: this.partnerName })"
              label-for="user_password"
            >
              <b-form-input
                id="user_password"
                v-model="userForm.password"
                :placeholder="$t('enter_user_password')"
                type="password"
                required
              ></b-form-input>
            </b-form-group>

            <br />
            <b-button block type="submit" variant="primary">{{
              $t("auth_in_partner_service", {service: this.partnerName})
            }}</b-button>
          </b-form>
        </b-col>
      </b-row>
    </div>

    <b-col v-if="loading" class="text-center mt-4">
      <b-spinner type="grow" :label="$t('loading')"></b-spinner>
    </b-col>
  </div>
</template>

<script>
import sha256 from 'crypto-js/sha256'
import Auth from '../components/Auth.vue'
import api from '../api'

export default {
  components: {
    Auth,
  },
  data() {
    return {
      userForm: {
        login: '',
        password: '',
      },
      error: null,
      loading: false,
      oauthParams: {
        client_id: '',
        service: '',
      },
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t('available_connections_page'),
          to: '/oauth/available',
        },
        {
          text: this.$t('oauth_tokens_btn'),
          active: true,
        },
      ]
    },

    partnerName() {
      switch (this.oauthParams.service) {
        case 'ajax':
          return this.$t('ajax')
        case 'yeelight':
          return this.$t('yeelight')
        case 'yeelight_pro':
          return this.$t('yeelight')
        case 'netatmo':
          return this.$t('netatmo')
        default:
          return this.$t('unknow_parner_client_id')
      }
    },

    region() {
      return this.$root.$data.state.choosedRegion
    },
    isAuthInCurrentRegion() {
      return (
        this.region
        && this.$root.$data.state.auth
        && this.$root.$data.state.auth.token
        && this.$root.$data.state.auth.expTokenJsTimestamp > Date.now()
      )
    },
  },
  methods: {
    partnerAuth() {
      this.loading = true
      // let url = ''
      // if (this.oauthParams.service === 'netatmo') {
      //   url = `https://legrand.cws.iridi.com/api/oauth2screen/${this.oauthParams.service}/login`
      // } else {
      //   url = `https://cws.iridi.com/api/oauth2screen/${this.oauthParams.service}/login`
      // }
      const url = `https://cws.iridi.com/api/oauth2screen/${this.oauthParams.service}/login`
      api.cwsBack
        .post(url, {
          login: this.userForm.login,
          passwordHash: sha256(this.userForm.password).toString(),
        })
        .then((res) => res.data)
        .then((res) => {
          if (res.error) {
            this.handleError(res.error)
          } else {
            this.$router.replace(`${this.oauthParams.redirect_uri}?code=${res.data}&state=${this.oauthParams.state}`)
          }
        })
        .catch(({ response }) => {
          this.handleError(response)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleError(response, code) {
      if (code === 200) {
        this.error = response
      } else if (response && response.status !== 500) {
        this.error = response.data.error
      } else {
        this.error = {
          type: this.$t('server_error'),
          description: this.$t('try_again_later'),
        }
      }
    },
  },
  mounted() {
    this.oauthParams = this.$route.query
  },
}
</script>
